var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerPortrait5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.4583in",
    height: "1.4583in",
    viewBox: "0 0 37.042 37.042",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 54.811,
    x2: 91.853,
    y1: 32.815,
    y2: 32.815,
    gradientTransform: "translate(-54.815,-14.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b3a995",
    offset: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 72.605,
    x2: 90.771,
    y1: 150.69,
    y2: 150.69,
    gradientTransform: "matrix(1.3369 0 0 .74799 -90.693 -89.263)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7e7867",
    offset: 0
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-120.69 -116.99)",
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 215.9,
    height: 279.4,
    fill: "#fcfcfc",
    style: {
      paintOrder: "markers fill stroke"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.0000024414,
    y: -0.0000021362,
    width: 37.042,
    height: 37.042,
    ry: 2.0045,
    fill: "url(#a)",
    style: {
      fill: "url(#a)",
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.5 4.1198a9.013 9.013 0 0 0-9.008 8.9749h-0.0020671v6.5435h5.167e-4a3.7645 3.7645 0 0 0 3.7647 3.7647v-0.96638a2.6043 2.6043 0 0 0 2.1302 1.1054v-0.077h-0.0031v-4.5709h6.2391v4.5709h-5.17e-4v0.077a2.6043 2.6043 0 0 0 2.1302-1.1059v0.9669a3.7645 3.7645 0 0 0 3.7647-3.7647h5.17e-4v-6.5052-0.037725h-0.001034a9.013 9.013 0 0 0-9.0121-8.9754 9.013 9.013 0 0 0-0.002584 0h-5.17e-4z",
    style: {
      fill: "#615b4c",
      fontVariationSettings: "normal",
      stopColor: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeWidth: 0.544
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.79 17.25c-1.118 0-2.0312 0.91128-2.0312 2.0293 0 1.118 0.91322 2.0312 2.0312 2.0312 1.118 0 2.0293-0.91322 2.0293-2.0312 0-1.118-0.91128-2.0293-2.0293-2.0293zm0 0.54297c0.82403 0 1.4863 0.6623 1.4863 1.4863s-0.6623 1.4863-1.4863 1.4863-1.4863-0.6623-1.4863-1.4863 0.6623-1.4863 1.4863-1.4863z",
    style: {
      InkscapeStroke: "none",
      color: "#000000",
      fill: "#d3cdc3",
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeWidth: 0.544
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.32 17.25c-1.118 0-2.0293 0.91128-2.0293 2.0293 0 1.118 0.91127 2.0312 2.0293 2.0312 1.118 0 2.0312-0.91322 2.0312-2.0312 0-1.118-0.91323-2.0293-2.0312-2.0293zm0 0.54297c0.82402 0 1.4863 0.6623 1.4863 1.4863s-0.6623 1.4863-1.4863 1.4863c-0.82403 0-1.4863-0.6623-1.4863-1.4863s0.6623-1.4863 1.4863-1.4863z",
    style: {
      InkscapeStroke: "none",
      color: "#000000",
      fill: "#d3cdc3",
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeWidth: 0.544
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.238 13.133c-0.004853 0.10955-0.007751 0.21943-0.007751 0.33022v2.0056c0 4.0295 3.2437 7.2732 7.2732 7.2732h5.16e-4c4.0295 0 7.2732-3.2437 7.2732-7.2732v-2.0056c0-0.11079-0.002898-0.22067-0.007751-0.33022h-14.531z",
    style: {
      InkscapeStroke: "none",
      fill: "#968c77",
      fontVariationSettings: "normal",
      paintOrder: "normal",
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.55 23.45a12.143 12.143 0 0 0-6.0999 1.6268 12.143 12.143 0 0 0-6.0715 10.517v1.4449h24.287v-1.4449a12.143 12.143 0 0 0-6.0715-10.517 12.143 12.143 0 0 0-6.0441-1.6268z",
    fill: "url(#b)",
    stopColor: "#000000",
    style: {
      fill: "url(#b)",
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.93,
    y: 18.78,
    width: 5.174,
    height: 7.7654,
    ry: 2.7045,
    fill: "#968c77",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-94.741,-96.287)",
    fill: "#d3cdc3",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m108.12 126.92a3.2092 5.3189 0 0 1-3.1905 5.3184v1.0597h16.728v-1.0597a3.2092 5.3189 0 0 1-3.1905-5.3184z",
    stopColor: "#000000",
    strokeWidth: 0.87746
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.29 120.06a12.143 12.143 0 0 0-2.1678 0.78083v9.9627h2.1678zm6.0224 0v10.744h2.1683v-9.9632a12.143 12.143 0 0 0-2.1683-0.78031z",
    stopColor: "#000000",
    strokeWidth: 0.3809
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-48.489 -130.78)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.472,
    cy: 145.95,
    rx: 2.0398,
    ry: 1.4861,
    fill: "#d3cdc3",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.472,
    cy: 145.95,
    rx: 0.885,
    ry: 1.2626,
    fill: "#413e35",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.541,
    cy: 145.95,
    rx: 2.0398,
    ry: 1.4861,
    fill: "#d3cdc3",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.541,
    cy: 145.95,
    rx: 0.885,
    ry: 1.2626,
    fill: "#413e35",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerPortrait5);
export default __webpack_public_path__ + "static/media/player-portrait-5.1685e6555de8e2729a19637ad9449cb4.svg";
export { ForwardRef as ReactComponent };